/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { isColliding } from '../utils/collider'
import { cssParser } from '../utils/parser'

const Switch = ({ css, onComplete }) => {
    const isLevelComplete = () => {
        return isColliding(document.getElementById("finger"), document.getElementById("switch"));
    }

    useEffect(() => {
        if (isLevelComplete()) {
            onComplete();
        }
    }, [css])

    return (
        <div id="switch-level">
            <div>
                <div id="hand-parent" style={cssParser(css)}>
                    <img height={100} style={{ position: "absolute", top: "0px", left: "0px" }} src="/images/hand.png" alt="hand" />
                    <div id="finger" />
                    <p style={{ "zIndex": "10", "position": "absolute", left: "5px" }}>#hand</p>
                </div>
                <div id="switch" />
                <div id="switch-box">
                    {isLevelComplete() ? "ON" : "OFF"}
                </div>
            </div>
            {isLevelComplete() ?
                <img height={500} src='/images/circuit-on.png' alt="bulb-on" />
                :
                <img height={500} src='/images/circuit-off.png' alt="bulb-off" />}
        </div>
    )
}

export default Switch